import { DEFAULT_VIEW_TYPE_PERMISSIONS } from './ViewsMenu.constants';
export const getCommonViewPermissions = (commonViewPermissions) => {
    const { create } = commonViewPermissions || {};
    const { create: defaultCreate } = DEFAULT_VIEW_TYPE_PERMISSIONS.common;
    return {
        create: create === undefined ? defaultCreate : create,
    };
};
export const getCustomViewPermissions = (view) => {
    const { edit, open, pin, remove } = view.permissions || {};
    const { edit: defaultEdit, open: defaultOpen, pin: defaultPin, remove: defaultRemove, } = DEFAULT_VIEW_TYPE_PERMISSIONS.custom;
    return {
        edit: edit === undefined ? defaultEdit : edit,
        open: open === undefined ? defaultOpen : open,
        pin: pin === undefined ? defaultPin : pin,
        remove: remove === undefined ? defaultRemove : remove,
    };
};
export const getPredefinedViewPermissions = (view) => {
    const { open } = view.permissions || {};
    const { open: defaultOpen } = DEFAULT_VIEW_TYPE_PERMISSIONS.custom;
    return {
        open: open === undefined ? defaultOpen : open,
    };
};
//# sourceMappingURL=ViewsMenu.service.js.map